angular.module('genesisApp')
.constant('ACCESS_LEVELS', 
    [
        { id: 1, name: 'Default' }, 
        { id: 2, name: 'Admin' }
    ]
);

